import { render, staticRenderFns } from "./MinorRegistrationCompleted.vue?vue&type=template&id=f9ff1518&scoped=true&"
import script from "./MinorRegistrationCompleted.vue?vue&type=script&lang=js&"
export * from "./MinorRegistrationCompleted.vue?vue&type=script&lang=js&"
import style0 from "./MinorRegistrationCompleted.vue?vue&type=style&index=0&id=f9ff1518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ff1518",
  null
  
)

export default component.exports